import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
    cachonDelivery:[],
    visaPayment:[],
    isLoading: true,
    isSuccess: true,
    errorMessage: ""
};


// checkout Visa
export const PayByVisa = createAsyncThunk("payVisa/paybyvisa", async ({ cartId, body }) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.post(`/api/v1/orders/checkout-session/${cartId}`, body, config);
        return res; 
    } catch (error) {
        return error;
    }
})


// checkout on delivery
export const CashOnDelivery = createAsyncThunk("checkout/cashOnDelivery", async ({id,data}) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.post(`/api/v1/orders/${id}`, data, config);
        return res;
    } catch (error) {
        return error;
    }
})




const CheckOutSlice = createSlice({
    name: "CheckOut",
    initialState,
    reducers: {},
    extraReducers: {
        [CashOnDelivery.pending]: (state, action) => {
            state.isLoading = true
        },
        [CashOnDelivery.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.cachonDelivery = action.payload
        },
        [CashOnDelivery.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        },
        [PayByVisa.pending]: (state, action) => {
            state.isLoading = true
        },
        [PayByVisa.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.visaPayment = action.payload
        },
        [PayByVisa.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload
        }
    }
})

export default CheckOutSlice.reducer;